import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import zhCN from "./locales/zh_CN";
import en from "./locales/en";

const resources = {
  zh_CN: zhCN,
  en,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "zh_CN",
    defaultNS: "login",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
